import MainCatalogsEditorBase from '../MainCatalogsEditorBase';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import template from './AddressCategoriesEditor.html?raw';
import on from 'dojo/on';
import Edit from '../../../moreCore/UI/Edit/Edit';
import { MainCatalogSelect } from '../MainCatalogEditorTools';
import NumberInput from '../../../moreCore/UI/NumberInput/NumberInput';
import { MainCatalogTypes, MainCatalogs_Classes } from "../../_loadingHelpers/MainCatalogTypes";

class AddressCategoriesEditor extends compose(MainCatalogsEditorBase) {
    templateString: any = template;

    ac_Input_Description: MdsLax<InstanceType<typeof Edit>>;
    ac_Input_Note: MdsLax<InstanceType<typeof Edit>>;
    ac_Input_Order: MdsLax<InstanceType<typeof NumberInput>>;

    ac_Select_AddressMainCategory: MdsLax<InstanceType<typeof MainCatalogSelect>>;

    formData: MainCatalogTypes.AddressCategories_SaveData = {
        ID: "",
        is_new_status: null,
        description: "",
        note: "",
        order: null,
        address_main_category_id: ""
    };

    prepareFormData(data?: MainCatalogTypes.AddressCategories_LoadData): void {

        let mainCategoryId: string = null;

        if (data) {

            this.ac_Input_Description.setValue(data.description, true);
            this.ac_Input_Note.setValue(data.note, true);

            this.ac_Input_Order.setValue(data.order, true);

            this.ac_Select_AddressMainCategory.setCatalog(MainCatalogs_Classes.AddressMainCategory,
                this.translations["General_Label_AddressMainCategory"], true, data.ref_address_main_category.ID);

            mainCategoryId = data.ref_address_main_category.ID;

            this.formData.ID = data.ID;
            this.formData.is_new_status = false;
        } else {

            this.ac_Input_Description.setValue("", true);
            this.ac_Input_Note.setValue("", true);

            this.ac_Input_Order.setValue(null, true);

            this.ac_Select_AddressMainCategory.setCatalog(MainCatalogs_Classes.AddressMainCategory,
                this.translations["General_Label_AddressMainCategory"], true);
            this.ac_Select_AddressMainCategory.setValue(null);

            this.formData.ID = "";
            this.formData.is_new_status = true;
        }

        this.serializeFormData(mainCategoryId);
        this.originalData = JSON.stringify(this.formData);
        console.debug("ORIGINAL", this.originalData);
        this.StandbyStop();

        this.checkDirty();
    }

    serializeFormData(mainCategoryId?: string): void {

        this.formData.description = this.ac_Input_Description.getValue();
        this.formData.note = this.ac_Input_Note.getValue();

        this.formData.order = this.ac_Input_Order.getValue();

        mainCategoryId ? this.formData.address_main_category_id = mainCategoryId : this.formData.address_main_category_id = this.ac_Select_AddressMainCategory.getValue();

        console.debug("SERIALIZED DATA", this.formData);
    }

    _onChangeServiceCategoryInputData(): void {

        this.serializeFormData();
        this.checkDirty();
    }

    _onChangeInputNoteData(): void {

        this.fixNewLineInMultilineEdit(this.ac_Input_Note);

        this.serializeFormData();
        this.checkDirty();
    }

    isValid(): boolean {

        let b: boolean = true;

        if (!this.formData.description) b = false;

        if (!this.formData.address_main_category_id) {

            this.indicateErrorOnInput(this.ac_Select_AddressMainCategory.catalogLabelContainer, "w3-red");
            b = false;
        }

        return b;
    }

    closeMainGroupEdit(): void {

        this.ac_Select_AddressMainCategory.editForm?.close();
    }

    //BASE
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.entityClass = MainCatalogs_Classes.AddressCategory;

        this.ac_Input_Description.setMaxLength(255);
        this.ac_Input_Note.setMaxLength(2000);
        this.ac_Input_Note.setValidationEnabled(false);

        this.ac_Select_AddressMainCategory.placeAt(this.editFormLeftSection, "last");
        this.UiModder.domClass.add(this.ac_Select_AddressMainCategory.domNode, "w3-margin-left w3-margin-right sectionBG overflow");
        //this.UiModder.domClass.remove(this.ac_Select_AddressMainCategory.catalogButtonShowEdit, "w3-hide");

        on(this.ac_Select_AddressMainCategory, "change", lang.hitch(this, this._onChangeInputDataGeneric));

        on(this, "MainCatalogSelect_ShowHideAddChange", lang.hitch(this, this.closeMainGroupEdit));
        on(this, "CatalogEntityData_Save", lang.hitch(this, this.closeMainGroupEdit));
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

mdsLazyProto(AddressCategoriesEditor.prototype, {
  ac_Input_Description: () => (new Edit()),
  ac_Input_Note: () => (new Edit()),
  ac_Input_Order: () => (new NumberInput()),
  ac_Select_AddressMainCategory: () => (new MainCatalogSelect()),
});
export default mdsWidget(AddressCategoriesEditor);